export default __webpack_public_path__ + "static/comment-f3c1009d44361a07ff3ed79b905a3e1b.jpg";